import { render, staticRenderFns } from "./getUserConfigurationInstagram.vue?vue&type=template&id=3a94a4bc&scoped=true&"
import script from "./getUserConfigurationInstagram.vue?vue&type=script&lang=js&"
export * from "./getUserConfigurationInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a94a4bc",
  null
  
)

export default component.exports